import type { MapData } from '../engine/types.js';
import raw from './golarion-map.json' with { type: 'json' };

/**
 * Golarion Diplomacy: seven powers around the Inner Sea, 36 supply centres, 19 to solo.
 * The graph is generated by `src/data/build-golarion-map.py`; the rules are the published
 * page's, https://apriiori.com/golarion-diplomacy/.
 */
export const GOLARION_MAP: MapData = {
  ...(raw as unknown as Pick<MapData, 'provinces' | 'lifeAdjacency' | 'startingUnits' | 'startingCenters' | 'aliases'>),
  id: 'golarion',
  name: 'Golarion',
  powers: ['ANDORAN', 'CHELIAX', 'NIDAL', 'OSIRION', 'QADIRA', 'RAHADOUM', 'TALDOR'],
  powerWords: {
    andoran: 'ANDORAN',
    andoren: 'ANDORAN',
    cheliax: 'CHELIAX',
    chelish: 'CHELIAX',
    chelaxian: 'CHELIAX',
    nidal: 'NIDAL',
    nidalese: 'NIDAL',
    osirion: 'OSIRION',
    osirian: 'OSIRION',
    osiriani: 'OSIRION',
    qadira: 'QADIRA',
    qadiran: 'QADIRA',
    rahadoum: 'RAHADOUM',
    rahadoumi: 'RAHADOUM',
    taldor: 'TALDOR',
    taldan: 'TALDOR',
  },
  startYear: 4701,
  soloCentres: 19,
  neutralBuildCentres: ['abs'],
  rulesUrl: 'https://apriiori.com/projects/golarion-diplomacy/',
};

export default GOLARION_MAP;
